import React from "react";
import { SvgIcon } from "@material-ui/core";

/* from https://materialdesignicons.com/
 */

// export function IconShuffle(props) {
//   return (
//     <SvgIcon {...props}>
//       <path d="M0,75.2a6.43,6.43,0,0,0,6.74,6.49H18.55c8.89,0,14.31-2.78,20.07-9.67L49.85,58.5,60.64,71.58C66.75,79,73.39,81.69,82.32,81.69h8.5V92.33A4.79,4.79,0,0,0,96,97.46a5.44,5.44,0,0,0,3.71-1.37l19.87-16.55a4.75,4.75,0,0,0,0-7.52L99.66,55.37A5.69,5.69,0,0,0,96,54a4.81,4.81,0,0,0-5.13,5.18v9.57H82.57C76.71,68.75,73,66.89,69,62L58,48.73,69,35.35c4.15-5,7.28-6.74,13-6.74h8.79v9.72A4.79,4.79,0,0,0,96,43.46a5.44,5.44,0,0,0,3.71-1.37l19.87-16.55a4.75,4.75,0,0,0,0-7.52L99.66,1.37A5.69,5.69,0,0,0,96,0a4.81,4.81,0,0,0-5.13,5.18V15.72H82.37c-9.42,0-15.57,2.59-22.26,10.74L49.8,38.87,38.62,25.39C32.86,18.46,26.81,15.72,18,15.72H6.74a6.48,6.48,0,1,0,0,12.94H17c5.62,0,9.62,1.86,13.62,6.74l11,13.28L30.66,62c-4.05,4.88-7.42,6.74-13,6.74H6.74A6.45,6.45,0,0,0,0,75.2Z" />
//     </SvgIcon>
//   );
// }
export function IconShuffle() {
  return (
    <svg width="100%" height="100%"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.38 97.46">
      <path
        fill="#ff0000"
        d="M0,75.2a6.43,6.43,0,0,0,6.74,6.49H18.55c8.89,0,14.31-2.78,20.07-9.67L49.85,58.5,60.64,71.58C66.75,79,73.39,81.69,82.32,81.69h8.5V92.33A4.79,4.79,0,0,0,96,97.46a5.44,5.44,0,0,0,3.71-1.37l19.87-16.55a4.75,4.75,0,0,0,0-7.52L99.66,55.37A5.69,5.69,0,0,0,96,54a4.81,4.81,0,0,0-5.13,5.18v9.57H82.57C76.71,68.75,73,66.89,69,62L58,48.73,69,35.35c4.15-5,7.28-6.74,13-6.74h8.79v9.72A4.79,4.79,0,0,0,96,43.46a5.44,5.44,0,0,0,3.71-1.37l19.87-16.55a4.75,4.75,0,0,0,0-7.52L99.66,1.37A5.69,5.69,0,0,0,96,0a4.81,4.81,0,0,0-5.13,5.18V15.72H82.37c-9.42,0-15.57,2.59-22.26,10.74L49.8,38.87,38.62,25.39C32.86,18.46,26.81,15.72,18,15.72H6.74a6.48,6.48,0,1,0,0,12.94H17c5.62,0,9.62,1.86,13.62,6.74l11,13.28L30.66,62c-4.05,4.88-7.42,6.74-13,6.74H6.74A6.45,6.45,0,0,0,0,75.2Z"
      />
    </svg>
  );
}

export function IconUndo(props) {
  return (
    <svg width="90%" height="90%"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.68 94.68">
      <path d="M94.68,61.23c0-20-13.53-33.84-35.6-33.84H30.13L19,27.88l8-6.64L38,10.4A5.8,5.8,0,0,0,40,6a5.79,5.79,0,0,0-6.1-6,6.66,6.66,0,0,0-4.54,1.9L1.9,29.05a6.55,6.55,0,0,0,0,9.23l27.45,27.1a6.72,6.72,0,0,0,4.54,2A6,6,0,0,0,38,56.88L27,46,19,39.4l11.18.54H59c14.8,0,23.34,8.64,23.34,21S73.78,82.13,59,82.13H47.41a6.28,6.28,0,1,0,0,12.55H59.62C81.35,94.68,94.68,81.49,94.68,61.23Z" />
    </svg>
  );
}

export function IconRedo(props) {
  return (
    <svg width="90%" height="90%"    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.68 94.68">
      <path d="M35.06,94.68H47.27a6.28,6.28,0,1,0,0-12.55H35.69c-14.79,0-23.34-8.89-23.34-21.19s8.55-21,23.34-21H64.55l11.18-.54-8,6.64L56.64,56.88a6,6,0,0,0,4.15,10.45,6.72,6.72,0,0,0,4.54-2l27.44-27.1a6.53,6.53,0,0,0,0-9.23L65.33,1.9A6.66,6.66,0,0,0,60.79,0a5.79,5.79,0,0,0-6.1,6,5.8,5.8,0,0,0,2,4.39L67.72,21.24l8,6.64-11.18-.49H35.6C13.53,27.39,0,41.21,0,61.23,0,81.49,13.33,94.68,35.06,94.68Z" />
    </svg>
  );
}

export function IconDown(props) {
  return (
    <svg width="20%" height="30%"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.7 113.13">
      <path 
      fill="#ff0000"
      d="M44.87,0a5.13,5.13,0,0,0-5.12,5V53.42l.44,7.18L37.4,56.88,31,50.1a4.55,4.55,0,0,0-3.32-1.47,4.35,4.35,0,0,0-3.13,7.52L40.87,71.83a5.5,5.5,0,0,0,4,1.75,5.4,5.4,0,0,0,4-1.75L65.14,56.15A4.28,4.28,0,0,0,66.55,53a4.35,4.35,0,0,0-4.44-4.35,4.77,4.77,0,0,0-3.42,1.47l-6.35,6.78L49.51,60.6,50,53.42V5A5.09,5.09,0,0,0,44.87,0ZM16.65,113.13h56.4c10.89,0,16.65-5.76,16.65-16.55V49.17c0-10.79-5.76-16.55-16.65-16.55H60.2V43.8H72c4.2,0,6.54,2.15,6.54,6.59v45c0,4.39-2.34,6.54-6.54,6.54H17.68c-4.25,0-6.5-2.15-6.5-6.54v-45c0-4.44,2.25-6.59,6.5-6.59h12V32.62h-13C5.81,32.62,0,38.38,0,49.17V96.58C0,107.37,5.81,113.13,16.65,113.13Z" />
    </svg>
  );
}

export function IconDownInvert(props) {
  return (
    <svg width="20%" height="30%"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.7 113.13">
      <path 
      fill="#ffffff"
      d="M44.87,0a5.13,5.13,0,0,0-5.12,5V53.42l.44,7.18L37.4,56.88,31,50.1a4.55,4.55,0,0,0-3.32-1.47,4.35,4.35,0,0,0-3.13,7.52L40.87,71.83a5.5,5.5,0,0,0,4,1.75,5.4,5.4,0,0,0,4-1.75L65.14,56.15A4.28,4.28,0,0,0,66.55,53a4.35,4.35,0,0,0-4.44-4.35,4.77,4.77,0,0,0-3.42,1.47l-6.35,6.78L49.51,60.6,50,53.42V5A5.09,5.09,0,0,0,44.87,0ZM16.65,113.13h56.4c10.89,0,16.65-5.76,16.65-16.55V49.17c0-10.79-5.76-16.55-16.65-16.55H60.2V43.8H72c4.2,0,6.54,2.15,6.54,6.59v45c0,4.39-2.34,6.54-6.54,6.54H17.68c-4.25,0-6.5-2.15-6.5-6.54v-45c0-4.44,2.25-6.59,6.5-6.59h12V32.62h-13C5.81,32.62,0,38.38,0,49.17V96.58C0,107.37,5.81,113.13,16.65,113.13Z" />
    </svg>
  );
}

export function AmplitudeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M 0,12 C 0,12 5,32 12,12 18.75,-8.75 24,12 24,12" />
    </SvgIcon>
  );
}

export function ContrastIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <path
        fill="#000000"
        d="M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22A10 10 0 0 0 22 12A10 10 0 0 0 12 2M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20V4Z"
      />
    </svg>
  );
}
